import "./easyincentivizer.scss";
import "../../src-utilities/footer";
import "../../src-utilities/header";
import JustValidate from "../../../node_modules/just-validate/dist/just-validate.es";

const getInTouch = document.getElementById("get-in-touch-form");

const getInTouchData = new JustValidate(getInTouch);

getInTouchData
  .addField("#git-fullName", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
    {
      rule: "customRegexp",
      value: /^(?=\S)([A-Za-z.]+(?:\s+[.A-Za-z]+){1,})$/,
      errorMessage: "Enter Valid Full Name",
    },
  ])
  .addField("#git-companyName", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
  ])
  .addField("#git-email", [
    {
      rule: "required",
    },
    {
      rule: "email",
    },
    {
      rule: "customRegexp",
      value:
        /^[a-zA-Z0-9](?:[a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,7})+$/,
      errorMessage: "Please enter a valid email",
    },
  ])
  .addField("#git-jobtitle", [
    {
      rule: "required",
    },
    {
      rule: "minLength",
      value: 2,
    },
  ])
  .addField("#git-country", [
    {
      rule: "required",
    },
    {
      validator: (value) => {
        return value !== "none";
      },
      errorMessage: "The field is required",
    },
  ])
  .addField("#git-lcode", [
    {
      rule: "required",
      errorMessage: "Code is required",
    },
    {
      validator: (value) => {
        return value !== "none";
      },
      errorMessage: "The field is required",
    },
  ])
  .addField("#git-phone", [
    {
      rule: "required",
      errorMessage: "The field is required",
    },
    {
      rule: "minLength",
      value: 4,
      errorMessage: "Minimum length is 4",
    },
    {
      rule: "customRegexp",
      value: /^[0-9]+$/,
    },
    {
      rule: "maxLength",
      value: 15,
      errorMessage: "Maximum length is 15",
    },
    {
      rule: "number",
    },
  ])
  .addField("#git-message", [
    {
      rule: "required",
    },
  ]);

let GoogleSendURL =
  "https://script.google.com/macros/s/AKfycbyML8OHUDSwwvY_QcBlZ2uHYN_rQIx_VlWZPLjpxoJ9dB8GQEr6J7U0D8kNzC3-p0nH/exec";

let loader = document.querySelector(".loader");

getInTouch.addEventListener("submit", (event) => {
  event.preventDefault();
  if (getInTouchData.isValid == false) {
    return false;
  }

  loader.classList.add("active");

  let formData = new FormData(event.target);

  let fullName = formData.get("lfirstname").split(" ");
  let firstName, lastName;
  [firstName, ...lastName] = fullName;
  lastName = lastName.join(" ");

  formData.set("lfirstname", firstName);
  formData.set("llastname", lastName);
  formData.append("sendurlvalue", window.location.href);
  formData.append("lsource", "Website Form - Easy Incentivizer contactus");

  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify({
    firstName: formData.get("lfirstname"),
    lastName: formData.get("llastname"),
    email: formData.get("lemail"),
    company: formData.get("lcompany"),
    phone: formData.get("phonecode") + " " + formData.get("lphone"),
    country: formData.get("lcountry"),
    jobTitle: formData.get("ljobtitle"),
    description: formData.get("Description"),
    leadSource: formData.get("lsource"),
    interestedServices: formData.get("category"),
    websiteVisitURL: window.location.href,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const googleRequestOptions = {
    method: "GET",
    redirect: "follow",
  };

  let request = "?";
  [...formData].forEach(([key, value], index) => {
    request += `${index === 0 ? "" : "&"}${key + "=" + value}`;
  });

  fetch(
    "https://us-west1-zoho-crm-scripts.cloudfunctions.net/queueLeadHttp",
    requestOptions,
  )
    .then((response) => response.text())
    .then((result) => {
      fetch(GoogleSendURL + request, googleRequestOptions)
        .then((response) => response.text())
        .then((result) => {
          $zoho.salesiq.visitor.uniqueid();
          $zoho.salesiq.visitor.name(firstName + " " + lastName);
          $zoho.salesiq.visitor.email(formData.get("lemail"));
          window.location.href = "https://products.cyntexa.com/success/";
          loader.classList.remove("active");
        })
        .catch((error) => console.error(error));
    })
    .catch((error) => console.error(error));
});

BindEvent();

function BindEvent() {
  const accordions = document.querySelectorAll(".accordian");

  accordions.forEach((acc) => {
    acc.addEventListener("click", function (e) {
      e.preventDefault();

      const parentWrapper = this.closest(".accordiancover");

      const isActive = parentWrapper.classList.contains("active");

      document.querySelectorAll(".accordiancover").forEach((wrapper) => {
        wrapper.classList.remove("active");

        const btn = wrapper.querySelector(".accordian");
        if (btn) btn.setAttribute("aria-expanded", "false");
      });

      if (!isActive) {
        parentWrapper.classList.add("active");
        this.setAttribute("aria-expanded", "true");
      }
    });
  });
}
